/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const OrderStateNew = {
  Open: "OPEN",
  Paying: "PAYING",
  Paid: "PAID",
  Processed: "PROCESSED",
  Capturing: "CAPTURING",
  Cancelled: "CANCELLED",
  Refunding: "REFUNDING",
  Refunded: "REFUNDED",
  PartiallyRefunded: "PARTIALLY_REFUNDED",
} as const;

export type OrderStateNew = (typeof OrderStateNew)[keyof typeof OrderStateNew];

export type OrderStateNewEnumType = typeof OrderStateNew;
export type OrderStateNewOptional = OrderStateNew;
export type OrderStateNewTrackedI = OrderStateNew;
export type OrderStateNewTracked = OrderStateNew;
export type OrderStateNewMetaI = EnumMetaType<
  OrderStateNewEnumType,
  OrderStateNew
>;
export const OrderStateNewMeta = typeMetaEnum<
  OrderStateNewEnumType,
  OrderStateNew
>("OrderStateNew", OrderStateNew);
export function transformDatesOrderStateNew(model: OrderStateNew) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
